import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../../../../../state/reducers';

const mapState = ({ queryParams }: StateType) => ({
  query: queryParams.userQuery,
});

export const Connect = connect(mapState, {});

export type PropsFromRedux = ConnectedProps<typeof Connect>;
